import FormatUtils from '@front/squirtle/utils/format'
import { I18n } from '@front/volcanion'

class Callbacks {
  static recordToFormHandler() {
    return function recordToForm(record) {
      return {
        status: FormatUtils.getStatus(_.pick(record?.auth, ['active', 'deleted', 'suspendedUntil', 'suspendedSince'])),
        auth: {
          gsm: record?.auth?.gsm,
          email: record?.auth?.email,
          gsm_verified: record?.auth?.gsm_verified,
          application: record?.auth?.application
        },
        customerinfo: {
          client_number: record?.customerinfo?.client_number,
          name: record?.customerinfo?.name,
          email: record?.customerinfo?.email,
          special_price: record?.customerinfo?.special_price,
          auth_account: record?.customerinfo?.auth_account,
          fee_rate: record?.customerinfo?.fee_rate,
          fixed_fee: record?.customerinfo?.fixed_fee,
          comment_to_driver: record?.customerinfo?.comment_to_driver,
          comment_to_call_taker: record?.customerinfo?.comment_to_call_taker,
          last_order_date: record?.customerinfo?.last_order_date,
          first_order_date: record?.customerinfo?.first_order_date,
          ivr_access: record?.customerinfo?.ivr_access,
          driver_options: _.map(record?.customerinfo?.driver_options, 'user_option_id'),
          vehicle_options: _.map(record?.customerinfo?.vehicle_options, 'vehicle_option_id'),
          customer_billed_id: record?.customerinfo?.customer_billed_id?.user_id,
          hide_driverinfo: record?.customerinfo?.hide_driverinfo,
          priority: record?.customerinfo?.priority
        },
        info: {
          first_name: _.get(record, 'info.first_name'),
          last_name: _.get(record, 'info.last_name'),
          gender: record?.info?.gender,
          address: _.get(record, 'info.address'),
          preferred_language: _.get(record, 'info.preferred_language')
        },
        preference: {
          waiting_duration: record?.preference?.waiting_duration,
          preferred_music: record?.preference?.preferred_music,
          open_door: record?.preference?.open_door,
          air_conditioning: record?.preference?.air_conditioning,
          temperature: record?.preference?.temperature,
          open_window: record?.preference?.open_window,
          armrest: record?.preference?.armrest,
        },
        address: _.get(record, 'payment_methods'),
        payment_methods: _.get(record, 'payment_methods'),
        deferred_billing: _.get(record, 'deferred_billing'),
        commercial_formula: _.get(record, 'commercial_formula'),
        createdAt: _.get(record, 'createdAt'),
        exclude_heatmap: record?.exclude_heatmap,
        bypass_heatmap_cascade: record?.bypass_heatmap_cascade,
        bonus_heatmap: record?.bonus_heatmap
      }
    }
  }

  static getEmptyFormHandler() {
    return function getEmptyFormValues() {
      return {
        status: 'active',
        customerinfo: {
          vehicle_options: [],
          driver_options: []
        }
      }
    }
  }

  static formToRecordHandler() {
    return function formToRecord(values, extra, meta, { suspended, ...state }) {
      return {
        status: FormatUtils.parseStatus(_.get(values, 'status'), _.pick(suspended, ['suspendedUntil', 'suspendedSince', 'motive'])),
        auth: {
          gsm: _.get(values, 'auth.gsm'),
          email: _.get(values, 'auth.email'),
          gsm_verified: _.get(values, 'auth.gsm_verified'),
          application: _.get(values, 'auth.application')
        },
        customerinfo: {
          client_number: _.get(values, 'customerinfo.client_number'),
          name: _.get(values, 'customerinfo.name'),
          email: _.get(values, 'customerinfo.email'),
          special_price: _.get(values, 'customerinfo.special_price'),
          auth_account: _.get(values, 'customerinfo.auth_account'),
          fee_rate: _.get(values, 'customerinfo.fee_rate'),
          fixed_fee: _.get(values, 'customerinfo.fixed_fee'),
          comment_to_driver: _.get(values, 'customerinfo.comment_to_driver'),
          comment_to_call_taker: _.get(values, 'customerinfo.comment_to_call_taker'),
          ivr_access: _.get(values, 'customerinfo.ivr_access'),
          driver_options: _.get(values, 'customerinfo.driver_options'),
          vehicle_options: _.get(values, 'customerinfo.vehicle_options'),
          customer_billed_id: _.get(values, 'customerinfo.customer_billed_id'),
          hide_driverinfo: values?.customerinfo?.hide_driverinfo,
          priority: values?.customerinfo?.priority
        },
        info: {
          first_name: _.get(values, 'info.first_name'),
          last_name: _.get(values, 'info.last_name'),
          gender: values?.gender,
          address: _.get(values, 'info.address'),
          preferred_language: _.get(values, 'info.preferred_language')
        },
        preference: {
          waiting_duration: values?.preference?.waiting_duration,
          preferred_music: values?.preference?.preferred_music,
          open_door: values?.preference?.open_door,
          air_conditioning: values?.preference?.air_conditioning,
          temperature: values?.preference?.temperature,
          open_window: values?.preference?.open_window,
          armrest: values?.preference?.armrest,
        },
        commercial_formula: _.get(values, 'commercial_formula'),
        address: _.get(values, 'payment_methods'),
        payment_methods: _.get(values, 'payment_methods'),
        deferred_billing: _.get(values, 'deferred_billing'),
        type: 'customer',
        exclude_heatmap: values?.exclude_heatmap,
        bypass_heatmap_cascade: values?.bypass_heatmap_cascade,
        bonus_heatmap: values?.bonus_heatmap
      }
    }
  }

  static recordToStateHandler() {
    return function recordToState(record) {
      return {
        user_auth_id: record?.auth?.user_auth_id,
        record_id: _.get(record, 'user_id'),
        title: _.get(record, 'customerinfo.client_number'),
        preferred_language: record?.info?.preferred_language || 'fr',
        suspended: {
          suspendedUntil: record?.auth?.suspendedUntil,
          suspendedSince: record?.auth?.suspendedSince,
          motive: record?.auth?.motive
        }
      }
    }
  }

  static formToOptionsHandler() {
    return function formToOptions(values, extra, meta, state) {
      return { force_order_cancel: !!extra?.forceSubmit }
    }
  }

  static onSubmitSuccessHandler(handleWelcomeAction, requestSubmitOrderLimit) {
    return async function onSubmitSuccess(result, values, extra, meta, state) {
      const user = result?.user_id || state?.record_id
      !!requestSubmitOrderLimit && requestSubmitOrderLimit({ user })

      if (!!values?.welcome_email)
        await handleWelcomeAction({ user_id: result?.user_id, channel: 'customer', adapter: 'email' })
      console.log("🚀 ~ file: callbacks.js ~ line 27 ~ Callbacks ~ onSubmitSuccess ~ result, values, extra, meta", result, values, extra, meta)

    }
  }

  static onSubmitFailedHandler(openDialog) {
    return async function onSubmitFailed(err, values, extra, meta) {
      if (err?.code === 'ACTIVE_JOBS')
        openDialog('show_active_jobs', {
          title: I18n.t('driver.popup.show_active_jobs.pending_orders.title'),
          description: I18n.t('driver.popup.show_active_jobs.pending_orders.description', { entity: I18n.t('driver.popup.show_active_jobs.entity.customer') }),
          job_ids: err?.context?.job_ids,
        })
    }
  }

  static getFailedNotificationHandler() {
    return function getFailedNotification(err, data, extra, meta, state) {
      const code = err.getCode()
      const context = err.getContext()
      if (code === 'RECORD_EXISTS' && _.get(context, 'key') === 'client_number') {
        return [I18n.t('error.already_exists.client_number'), { variant: 'error' }]
      }
      else if (code === 'RECORD_EXISTS' && _.includes(context?.key, 'gsm')) {
        return [I18n.t('error.already_exists.gsm'), { variant: 'error' }]
      }
      else if (code === 'RECORD_EXISTS' && _.includes(context?.key, 'email')) {
        return [I18n.t('error.already_exists.email'), { variant: 'error' }]
      }
    }
  }
  static confirmResetHandler(openDialog, client_number, user_id, application) {
    return async function confirmReset(method) {
      openDialog('confirm_reset_password', {
        title: I18n.t('password.reset.confirm.title'),
        description: I18n.t('password.reset.confirm.customer', { client_number, method }),
      }, { method, user_id, application }, { method, user_id, application }
      )
    }
  }
  static onResetSmsPasswordHandler(confirmReset) {
    return async function onResetSmsPassword() {
      confirmReset('sms')
    }
  }
  static onResetEmailPasswordHandler(confirmReset) {
    return async function onResetEmailPassword() {
      confirmReset('email')
    }
  }

  static confirmWelcomeEmailHandler(openDialog, client_number, user_id, application) {
    return async function confirmReset() {
      openDialog('confirm_welcome_email', {
        title: I18n.t('email.welcome.confirm.title'),
        description: I18n.t('email.welcome.confirm.customer', { client_number }),
      }, { method: 'email', user_id, application }, { method: 'email', user_id, application }
      )
    }
  }

  static handleCallHandler(EXTERNAL_PHONE_SERVICE) {
    return async function call(number) {
      if (!number) return
      if (EXTERNAL_PHONE_SERVICE === 'aws') {
        const endpoint = connect.Endpoint.byPhoneNumber(number)
        const agent = new connect.Agent()
        const contacts = agent.getContacts()
        if (_.isEmpty(contacts))
          agent.connect(endpoint)
        else if (contacts.length === 1)
          contacts[0].addConnection(endpoint)
      }
    }
  }

  static onKeyDownHandler(gsm, handleCall) {
    return async function onKeyDownHandler(event) {
      const { key, altKey, ctrlKey } = event

      if (key === 'F9' && !(!!altKey || !!ctrlKey)) {
        event.preventDefault()
        await handleCall(gsm)
      }

    }
  }
}

export default Callbacks
